import { Helmet } from 'react-helmet-async';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';

export default function BrandShieldKoBiddingManualTargetImpressionShare() {
  return (
    <>
      <Helmet>
        <title>Target Impression Share</title>
      </Helmet>

      <KeywordBased />
    </>
  );
}
